<template>
  <td v-bind="column.td">
    <slot :name="slotName">
      <span>{{item[column.value] || ''}}</span>
    </slot>
  </td>
</template>

<script>
  export default {
    name: 'BodyCellDefault',
    props: {
      item: Object,
      column: Object,
      type: String
    },
    computed: {
      slotName() {
        return (this.$scopedSlots[`item.${this.column.value}`]) ? `item.${this.column.value}` : undefined
      }
    },
  }
</script>

<style scoped>
  td{
    overflow: hidden;
    max-height: 49px;
    height: 49px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
